import React, { useState, useRef, useMemo, useEffect } from 'react';
import Tree from 'rc-tree';
import { If } from 'common/src/components';

import { DataNode, Key, EventDataNode } from 'rc-tree/lib/interface';
import './index.scss';
import { lang } from '@umu/ukit-lang';

interface ITreeNodeInfo {
    event: string;
    selected: boolean;
    node: EventDataNode;
    selectedNodes: DataNode[];
    nativeEvent: MouseEvent;
}
interface IProps {
    className?: string;
    treeData: DataNode[];
    selectedKeys?: Key[];
    hideIcon?: boolean;
    placeholder?: string;
    onSelect?: (selectedKeys: Key[], info: ITreeNodeInfo) => void;
    onChange?: (id: Key[]) => void;
}
const switcherIcon: any = (obj: { expanded: any; isLeaf: any }) => {
    if (obj.expanded && !obj.isLeaf) {
        return <i className="icons icon-more-open"></i>;
    }
    if (obj.isLeaf) {
        return null;
    }
    return <i className="icons icon-more-close"></i>;
};

export const TreeNode = (props: IProps) => {
    const { treeData, onSelect, selectedKeys, hideIcon = false } = props;
    return (
        <Tree
            treeData={treeData}
            prefixCls="umu-tree"
            selectedKeys={selectedKeys}
            switcherIcon={switcherIcon}
            itemHeight={20}
            icon={hideIcon ? '' : <i className="icons icon-file"></i>}
            onSelect={onSelect}
        />
    );
};
const getTreeLabelByKey = (keys: Key, list: DataNode[]) => {
    let label: string[] = [];
    list.forEach((item) => {
        if (item.key === keys) {
            label.push(item.title as string);
            return;
        } else if (item.children) {
            label = label.concat(getTreeLabelByKey(keys, item.children));
        }
    });
    return label;
};
const getTreeLabel = (keys: Key[], list: DataNode[]) => {
    let label: string[] = [];
    keys.forEach((_) => {
        label = label.concat(getTreeLabelByKey(_, list));
    });
    return label.toString();
};

export const SelectTree = (props: IProps) => {
    const { treeData = [], className = '' } = props;
    const [selectLabel, setSelectLabel] = useState<string>('');
    const [selectKeys, setSelectKeys] = useState<Key[]>(props.selectedKeys || []);
    const [isFold, setIsFold] = useState(true);
    const selectedRef = useRef<HTMLDivElement>(null);

    const onSelect = (selectedKeys: Key[], info: ITreeNodeInfo | undefined) => {
        setSelectLabel(!!info && info.node && info.node.title ? info.node.title.toString() : '');
        setSelectKeys(selectedKeys);
        setIsFold(true);
        if (props.onChange) {
            props.onChange(selectedKeys);
        }
    };
    const getLabel = () => {
        const selectLabel = getTreeLabel(props.selectedKeys || [], treeData);
        setSelectLabel(selectLabel);
    };

    useEffect(() => {
        if (props.selectedKeys && !props.selectedKeys.length) {
            setSelectKeys([]);
            setSelectLabel('');
        } else {
            getLabel();
        }
    }, [props.selectedKeys]);
    const isHasSelect = useMemo(() => {
        return selectKeys.length > 0;
    }, [selectKeys]);

    const onClick = () => {
        setIsFold(!isFold);
    };

    const onCancelClick = (event: { stopPropagation: () => void }) => {
        event.stopPropagation();
        onSelect([], undefined);
    };

    const onMouseMove = () => {
        setIsFold(true);
    };

    return (
        <div className={`category-course-selected ${isFold ? '' : 'selected-active'} ${className}`}>
            <div ref={selectedRef} className="selected" onClick={onClick}>
                <div title={selectLabel || props.placeholder}>{selectLabel || props.placeholder}</div>
                <If condition={isHasSelect && !!selectLabel}>
                    <i className="icon icon-clear" onClick={onCancelClick} />
                </If>
                <i className={`icon icon-arrow ${isFold ? 'up' : 'down'}`} />
            </div>
            <div className={`tree-select-panel ${isFold ? 'hide' : ''}`} onMouseLeave={onMouseMove}>
                {treeData.length > 0 ? (
                    <TreeNode
                        selectedKeys={selectKeys}
                        treeData={treeData}
                        onSelect={onSelect}
                        hideIcon={true}
                    ></TreeNode>
                ) : (
                    <div className="tree-select-panel-empty-text">{lang('暂无分类')}</div>
                )}
            </div>
        </div>
    );
};
